import { useEffect, useRef, useState } from 'react';
import { API_BASE } from '../config/api';

/**
 * Heartbeats the current user into an exam's live "người đang làm bài" set while
 * `active` is true, and returns the current concurrent-taker count. Best-effort:
 * silently no-ops on network/Redis failure. Sends a `leave` beacon on unmount.
 */
export default function useLivePresence(examId, active) {
  const [count, setCount] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!active || !examId) return;
    const token = localStorage.getItem('token');
    let cancelled = false;

    const beat = async () => {
      try {
        const res = await fetch(`${API_BASE}/student/live-presence/${examId}/heartbeat`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          if (!cancelled) setCount(data.count || 0);
        }
      } catch (e) {
        /* best-effort */
      }
    };

    beat();
    intervalRef.current = setInterval(beat, 15000);

    return () => {
      cancelled = true;
      if (intervalRef.current) clearInterval(intervalRef.current);
      try {
        fetch(`${API_BASE}/student/live-presence/${examId}/leave`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` },
          keepalive: true,
        });
      } catch (e) {
        /* best-effort */
      }
    };
  }, [examId, active]);

  return count;
}
